import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà accepté les cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Afficher la bannière après un court délai
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Overlay sombre */}
      <div className="fixed inset-0 bg-black/30 z-[9998] backdrop-blur-sm"></div>

      {/* Bannière de cookies */}
      <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 sm:p-6 animate-slide-up">
        <div className="max-w-6xl mx-auto bg-white rounded-2xl sm:rounded-3xl shadow-2xl border-2 border-clinic-blue/20">
          <div className="p-4 sm:p-6 md:p-8">
            {/* Header */}
            <div className="flex items-start gap-3 sm:gap-4 mb-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-clinic-blue/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-cookie-line text-xl sm:text-2xl text-clinic-blue"></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-clinic-blue-dark mb-2">
                  🍪 Gestion des Cookies
                </h3>
                <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">
                  Nous utilisons des cookies pour assurer le bon fonctionnement de notre plateforme médicale, 
                  sécuriser vos données de santé et améliorer votre expérience. Les cookies strictement nécessaires 
                  sont indispensables pour accéder à votre dossier médical en toute sécurité.
                </p>
              </div>
            </div>

            {/* Types de cookies */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4 sm:mb-6">
              <div className="bg-clinic-green/10 border border-clinic-green/30 p-3 rounded-xl">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-shield-check-line text-clinic-green text-sm sm:text-base"></i>
                  <span className="text-xs sm:text-sm font-semibold text-clinic-blue-dark">Nécessaires</span>
                </div>
                <p className="text-xs text-gray-600">
                  Authentification et sécurité de vos données médicales
                </p>
              </div>

              <div className="bg-gray-50 border border-gray-200 p-3 rounded-xl">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-settings-3-line text-clinic-blue text-sm sm:text-base"></i>
                  <span className="text-xs sm:text-sm font-semibold text-clinic-blue-dark">Fonctionnels</span>
                </div>
                <p className="text-xs text-gray-600">
                  Préférences et paramètres personnalisés
                </p>
              </div>

              <div className="bg-gray-50 border border-gray-200 p-3 rounded-xl">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-bar-chart-line text-clinic-blue text-sm sm:text-base"></i>
                  <span className="text-xs sm:text-sm font-semibold text-clinic-blue-dark">Analytiques</span>
                </div>
                <p className="text-xs text-gray-600">
                  Amélioration de la plateforme
                </p>
              </div>
            </div>

            {/* Boutons d'action */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4">
              <button
                onClick={handleAcceptAll}
                className="flex-1 sm:flex-none px-6 py-3 bg-clinic-blue text-white rounded-full hover:bg-clinic-blue-dark transition-all duration-300 font-semibold text-sm whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <i className="ri-check-line mr-2"></i>
                Tout accepter
              </button>

              <button
                onClick={handleAcceptNecessary}
                className="flex-1 sm:flex-none px-6 py-3 bg-white border-2 border-clinic-blue text-clinic-blue rounded-full hover:bg-clinic-blue/5 transition-all duration-300 font-semibold text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shield-check-line mr-2"></i>
                Nécessaires uniquement
              </button>
            </div>

            {/* Note légale */}
            <p className="text-xs text-gray-500 mt-4 text-center">
              <i className="ri-shield-line mr-1"></i>
              Vos données médicales sont protégées conformément à la loi n°2017-20 du Bénin
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.5s ease-out;
        }
      `}</style>
    </>
  );
}
